import React from "react";
import s from "./style.module.scss";
import { Link } from "react-router-dom";
import { IGift } from "widgets/MyGiftsList/api/models";
import ImageLazy from "shared/ui/ImageLazy";

const MyGift: React.FC<IGift> = ({
  activated,
  period_to,
  period_from,
  title,
  tr_num,
  image,
  id,
}) => {
  return (
    <li className={s.card}>
      <Link to={`/account/gift/${id}`} />

      <div className={s.image}>
        <ImageLazy src={image} alt="Gift" />
      </div>

      <div className={s.content}>
        {activated === 1 && (
          <div className={s.transaction}>
            <span>Номер транзакции</span>

            <div>{tr_num}</div>

            <span>{new Date(period_from).toLocaleDateString()}</span>
          </div>
        )}

        <h3>{title}</h3>

        <span className={s.shop}></span>

        <div className={s.bottom}>
          <div className={s.end}>
            до {new Date(period_to).toLocaleDateString()}
          </div>

          {
            <div className={s.activated}>
              {activated === 1 ? "Активировано" : "Ожидает активации"}
            </div>
          }
        </div>
      </div>
    </li>
  );
};

export default MyGift;
